import { RefObject } from "react";

import { useProductDescription } from "@/screens/app/components/dialogs/dialog_purchase/hooks";
import { Payment } from "@/screens/app/components/payment";

import { useContextDialogPurchase } from "../../context";

export const PurchasePayment = ({
  onReachGoal,
  onClose,
  refDialog,
}: {
  onReachGoal: () => void;
  onClose: (fireSuccessAction?: boolean) => void;
  refDialog: RefObject<HTMLDivElement>;
}) => {
  const {
    state: {
      paymentProviderSelected,
      productSelected,
      purchaseBill,
      purchaseRecurringPayment,
      purchaseStatus,
      redirectDisabled,
    },
  } = useContextDialogPurchase();
  const { description } = useProductDescription({ product: productSelected });

  return (
    <Payment
      onReachGoal={onReachGoal}
      onClose={onClose}
      refDialog={refDialog}
      status={purchaseStatus}
      description={description}
      provider={paymentProviderSelected}
      recurring={purchaseRecurringPayment}
      bill={purchaseBill}
      redirectDisabled={redirectDisabled}
    />
  );
};
